export const millisecondsToDays = (milliseconds) => Math.floor(milliseconds / (1000 * 60 * 60 * 24))
export const millisecondsToHours = (milliseconds) =>
  Math.floor((milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
export const millisecondsToMinutes = (milliseconds) => Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60))
export const millisecondsToSeconds = (milliseconds) => Math.floor((milliseconds % (1000 * 60)) / 1000)

export const dateToSeconds = (date) => Date.parse(date)
